import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "fs-13px fw-500 text-cool-gray-80 block q-mb-sm" }
const _hoisted_2 = { class: "fs-13px fw-500 text-cool-gray-80 block q-mb-sm" }
const _hoisted_3 = { class: "fs-13px fw-500 text-cool-gray-80 block q-mb-sm" }
const _hoisted_4 = { class: "row items-center justify-end" }
const _hoisted_5 = { class: "fs-13px fw-500 text-cool-gray-80 block q-mb-sm" }
const _hoisted_6 = { class: "row items-center justify-end" }
const _hoisted_7 = {
  key: 0,
  class: "fs-13px fw-500 text-cool-gray-80 block q-mb-sm"
}
const _hoisted_8 = { class: "column no-wrap gap-20" }

import _ from 'lodash'
import { date } from 'quasar'
import { IFilter } from 'src/common/interfaces'
import { reactive, watchEffect } from 'vue'

interface IProps {
  filter: IFilter
}

interface IFilterModel {
  [key: string]: unknown
}

interface IState {
  filter: IFilter | null
  dateTime: { [key: string]: string }
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LandingListFilterItem' },
  __name: 'LandingListFilterItem',
  props: /*@__PURE__*/_mergeModels({
    filter: {}
  }, {
    "modelValue": { type: Object, required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props
const filterModel = _useModel<IFilterModel>(__props, "modelValue")

const state = reactive<IState>({
  filter: null,
  dateTime: {},
})

function generateDateTimeDisplayKeys(filter: IFilter, fallbackName: string) {
  if (filter.type === 'date') {
    const key = filter.name ?? fallbackName
    state.dateTime[key] = ''
  }
}

function updateDateTimeFilterDisplay(value: string, field: string, mask = 'YYYY/MM/DD') {
  state.dateTime[field] = date.formatDate(value, mask)
}

watchEffect(() => {
  state.filter = props.filter
  state.dateTime = {}
  generateDateTimeDisplayKeys(state.filter, 'displayDate')
  if (state.filter.children) {
    _.forEach(state.filter.children, (filter, index) => {
      generateDateTimeDisplayKeys(filter, index.toString())
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_k_dropdown = _resolveComponent("k-dropdown")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_k_checkbox = _resolveComponent("k-checkbox")!
  const _component_LandingListFilterItem = _resolveComponent("LandingListFilterItem", true)!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Dropdown "),
    (__props.filter?.field && __props.filter?.type === 'dropdown')
      ? (_openBlock(), _createBlock(_component_k_dropdown, _mergeProps({
          key: 0,
          modelValue: filterModel.value[__props.filter?.field],
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterModel.value[__props.filter?.field]) = $event)),
          small: "",
          "options-mode": __props.filter?.bind?.multiple ? 'checkbox' : 'radio',
          "has-clear-icon": __props.filter?.bind?.multiple || 'default' in __props.filter,
          "default-value": __props.filter?.default
        }, __props.filter?.bind), {
          label: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(__props.filter?.label), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["modelValue", "options-mode", "has-clear-icon", "default-value"]))
      : (__props.filter?.field && __props.filter?.type === 'input')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Input "),
            _createVNode(_component_k_input, _mergeProps({
              modelValue: filterModel.value[__props.filter?.field],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterModel.value[__props.filter?.field]) = $event)),
              small: ""
            }, __props.filter?.bind), {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.filter?.label), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["modelValue"])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : (__props.filter?.type === 'separator')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" Separator "),
              _createVNode(_component_k_divider, _normalizeProps(_guardReactiveProps(__props.filter?.bind)), null, 16 /* FULL_PROPS */)
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : (__props.filter?.field && __props.filter?.type === 'date')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createCommentVNode(" Date "),
                _createElementVNode("div", null, [
                  _createVNode(_component_k_input, {
                    modelValue: state.dateTime[__props.filter?.name ?? 'displayDate'],
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.dateTime[__props.filter?.name ?? 'displayDate']) = $event)),
                    readonly: "",
                    small: "",
                    "has-clear-icon": false,
                    "default-readonly-style": "false",
                    placeholder: __props.filter?.bind?.placeholder,
                    "root-class": "flex-1"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.filter?.label), 1 /* TEXT */)
                    ]),
                    prepend: _withCtx(() => [
                      _createVNode(_component_k_btn, {
                        icon: "calendar",
                        size: "md",
                        "custom-color": "cool-gray-70",
                        model: "link"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, {
                            cover: "",
                            class: "LandingListFilterItem__datepicker",
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_date, {
                                modelValue: filterModel.value[__props.filter?.field],
                                "onUpdate:modelValue": [
                                  _cache[2] || (_cache[2] = ($event: any) => ((filterModel.value[__props.filter?.field]) = $event)),
                                  _cache[3] || (_cache[3] = ($event: any) => (updateDateTimeFilterDisplay($event, __props.filter?.field, __props.filter?.bind?.mask)))
                                ],
                                color: "dark-bg-20",
                                mask: "YYYY-MM-DD"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _withDirectives(_createVNode(_component_q_btn, {
                                      label: "Close",
                                      color: "primary",
                                      flat: ""
                                    }, null, 512 /* NEED_PATCH */), [
                                      [_directive_close_popup]
                                    ])
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "placeholder"])
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : (__props.filter?.field && __props.filter?.type === 'time')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createCommentVNode(" Time "),
                  _createElementVNode("div", null, [
                    _createVNode(_component_k_input, {
                      modelValue: filterModel.value[__props.filter?.field],
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterModel.value[__props.filter?.field]) = $event)),
                      readonly: "",
                      small: "",
                      "has-clear-icon": false,
                      "default-readonly-style": "false",
                      placeholder: __props.filter?.bind?.placeholder,
                      "root-class": "flex-1"
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.filter?.label), 1 /* TEXT */)
                      ]),
                      prepend: _withCtx(() => [
                        _createVNode(_component_k_btn, {
                          icon: "clock",
                          size: "md",
                          "custom-color": "cool-gray-70",
                          model: "link"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              cover: "",
                              class: "LandingListFilterItem__datepicker",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: filterModel.value[__props.filter?.field],
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterModel.value[__props.filter?.field]) = $event)),
                                  color: "dark-bg-20",
                                  mask: "HH:mm"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        label: "Close",
                                        color: "primary",
                                        flat: ""
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_directive_close_popup]
                                      ])
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "placeholder"])
                  ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (__props.filter?.field && __props.filter?.type === 'checkbox')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createCommentVNode(" Checkbox "),
                    _createVNode(_component_k_checkbox, {
                      modelValue: filterModel.value[__props.filter?.field],
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterModel.value[__props.filter?.field]) = $event)),
                      label: __props.filter?.label
                    }, null, 8 /* PROPS */, ["modelValue", "label"])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : (__props.filter?.type === 'group' && __props.filter?.children?.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createCommentVNode(" Group "),
                      _createElementVNode("div", null, [
                        (__props.filter?.label)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.filter?.label), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.children, (child, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createVNode(_component_LandingListFilterItem, {
                                modelValue: filterModel.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filterModel).value = $event)),
                                filter: child
                              }, null, 8 /* PROPS */, ["modelValue", "filter"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})